module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/254-nato-a90c292a2ff358b00e3c76da7fe3c41f.svg";